<template>
  <div>
    <v-layout row wrap>
      <v-flex grow>
        <h2 class="headline pb-3">Owner</h2>
      </v-flex>
      <v-flex shrink>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn flat icon color="primary" @click.stop="saveOwner()" v-on="on">
              <v-icon class="mr-1">save</v-icon>
            </v-btn>
          </template>
          <span>Save owner details</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-form ref="ownerInfo" v-model="valid" lazy-validation>
      <v-layout row>
        <v-flex xs6>
          <v-text-field
            v-model="selectedHouse.owner_firstname"
            label="First Name"
            required
            :rules="textRules"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            v-model="selectedHouse.owner_lastname"
            label="Last Name"
            required
            :rules="textRules"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs6>
          <v-text-field
            v-model="selectedHouse.owner_email"
            label="Email"
            required
            :rules="emailRules"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            v-model="selectedHouse.owner_phone"
            label="Phone"
            required
            :rules="textRules"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs6>
          <v-text-field
            v-model="selectedHouse.owner_bank_account"
            label="Bank Account Number"
            :rules="textRules"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout row wrap>
      <v-flex sm12>
        <v-checkbox v-model="selectedHouse.paycash"
          label="Check on this option if the host is paid with cash"
        />
      </v-flex>
    </v-layout>
    <v-layout v-if="selectedHouse.files.owner" row wrap>
      <v-flex sm6>
        <v-flex
          v-for="file in selectedHouse.files.owner"
          :key="file.id"
          xs12
        >
          <v-chip
            outline
            :close="true"
            class="width--auto"
            @input="
              deleteContractFile({
                id: file.id,
                type: 'owner',
                xId: selectedHouse.id
              })
            "
          >
            <v-avatar>
              <v-icon>attach_file</v-icon>
            </v-avatar>
            <a :href="getFileUrl(file.url)" target="new" class="no--underline">
              {{ file.name }}
            </a>
          </v-chip>
        </v-flex>
      </v-flex>
      <v-flex sm6 class="text-xs-right">
        <v-btn
          color="primary"
          type="file"
          @click.stop.prevent="initUpload()"
        >
          <v-icon dark>attach_file</v-icon>Add Files
        </v-btn>
        <input
          v-show="false"
          ref="ownerAttachment"
          type="file"
          @change="upload($event)"
        />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import config from '@/config'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DetailsOwner',
  data() {
    return {
      valid: true,
      textRules: [(v) => !!v || ''],
      emailRules: [
        (v) => !!v || '',
        (v) => /.+@.+\.+/.test(v) || 'E-mail must be valid',
      ],
    }
  },
  computed: {
    ...mapGetters({
      selectedHouse: 'HouseList/getSelectedHouse'
    })
  },
  methods: {
    ...mapActions({
      save: 'HouseList/updateHouse',
      uploadFile: 'HouseList/uploadFile',
      deleteContractFile: 'HouseList/deleteContractFile'
    }),
    getFileUrl(path) {
      return config.apiBaseUrl + path.substring(1)
    },
    saveOwner() {
      if(this.$refs.ownerInfo.validate()) {
        this.save(this.selectedHouse)
      }
    },
    initUpload() {
      this.$refs.ownerAttachment.click()
    },
    upload(event) {
      if (event.target.files.length > 0) {
        this.uploadFile({
          file: event.target.files[0],
          type: 'owner',
          houseId: parseInt(this.$route.params.houseId),
        })
      }
    },
  }
}
</script>
